import { render, staticRenderFns } from "./RemoveEndpointPrompt.vue?vue&type=template&id=94ab6672&"
import script from "./RemoveEndpointPrompt.vue?vue&type=script&lang=js&"
export * from "./RemoveEndpointPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94ab6672')) {
      api.createRecord('94ab6672', component.options)
    } else {
      api.reload('94ab6672', component.options)
    }
    module.hot.accept("./RemoveEndpointPrompt.vue?vue&type=template&id=94ab6672&", function () {
      api.rerender('94ab6672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/RemoveEndpointPrompt.vue"
export default component.exports